module.exports = __webpack_public_path__ + "img/20190914130037877.a96bbdc6.jpg";